import React from "react"
import { Link } from "gatsby"
import Logo from "../../images/avalith-logo.png"
import { FaLinkedin, FaFacebook, FaInstagram } from "react-icons/fa"
import Subscribe from "./Subscribe"

const Footer = () => {
  return (
    <footer className="mx-auto container px-6">
      <hr className="my-12 border-b-1 border-black dark:border-white" />
      <div className="grid grid-rows-1 grid-cols-1 md:grid-cols-2 lg:grid-cols-4 pb-12 gap-12 sm:gap-8">
        <div>
          <h4 className="text-2xl mb-4 font-semibold">Contact us</h4>
          <p className="text-base">hello@avalith.net</p>
          <p className="text-base">+54 223 464-4850</p>
        </div>      
        <Subscribe />
        <div>
          <h4 className="text-2xl mb-4 font-semibold">Follow us</h4>
          <a
            href="https://www.linkedin.com/company/avalith-net"
            title="Avalith in Linkedin"
            target="_blank"
            rel="noreferrer"
          >
            <FaLinkedin className="text-3xl inline-block mr-6 hover:text-secondary transition duration-500 ease-in-out" />
          </a>
          <a
            href="https://www.facebook.com/avalith.net"
            title="Avalith in Facebook"
            target="_blank"
            rel="noreferrer"
          >
            <FaFacebook className="text-3xl inline-block mr-6 hover:text-secondary transition duration-500 ease-in-out" />
          </a>
          <a
            href="https://www.instagram.com/avalithar"
            title="Avalith in Instagram"
            target="_blank"
            rel="noreferrer"
          >
            <FaInstagram className="text-3xl inline-block mr-6 hover:text-secondary transition duration-500 ease-in-out" />
          </a>
          {/* <a
            href="https://www.avalith.net"
            target="_blank"
            title="Avalith in Twitter"
            rel="noreferrer"
          >
            <FaTwitter className="text-3xl inline-block mr-6 hover:text-secondary transition duration-500 ease-in-out" />
          </a> */}
        </div>
        <div className="flex flex-col justify-center">
          <Link to="/">
            <img
              src={Logo}
              alt="Avalith"
              width="208"
              className="mx-auto block"
            />
          </Link>
        </div>
      </div>
      <div className="grid grid-rows-1 grid-cols-1 md:grid-cols-4 pb-12 gap-8 text-center">
        <p className="text-xs">All rights reserved 2020. Tres Cubos S.A.</p>
        <p className="text-xs">Privacy Policy</p>
        <Link to="/about-us/terms-of-use" className="text-xs">Terms of use</Link>
        <Link to="/about-us/contract" className="text-xs">Contract</Link>
      </div>
    </footer>
  )
}

export default Footer